// environments/environment.ts
export const environment = {
  production: false,
  baseUrl: "http://localhost:4200", // Angular base URL
  // baseUrl2: 'http://localhost:1020/' // Local Server URL
  baseUrl2: "https://msr.zirvecompany.net/", //  Production Server URL
};
